import React from 'react'

import MessageDeliveredIcon from 'assets/images/qn2c/messageDelivered.svg'
import ActionBase from 'components/pages/quarantineAction/ActionBase'
import ContentHeader from 'components/pages/quarantineAction/ContentHeader'
import EmailInfo from 'components/pages/quarantineAction/EmailInfo'

export interface DeliverActionProps {
  user: string
  headerFrom: string
  subject: string
  date: string
  onClick: () => void
  buttonLabel: string
  buttonBdsType: 'interactiveNeutral' | 'interactiveEmphasis'
  error: boolean
  errorContent: string
  loading: boolean
  icon: boolean
  content: { header: string; subHeader: string }
}

export const DeliverAction: React.FC<DeliverActionProps> = ({
  user,
  headerFrom,
  subject,
  date,
  onClick,
  buttonLabel,
  buttonBdsType,
  error,
  errorContent,
  loading,
  icon,
  content
}) => (
  <ActionBase
    onClick={onClick}
    buttonLabel={buttonLabel}
    buttonBdsType={buttonBdsType}
    error={error}
    errorContent={errorContent}
    loading={loading}
    icon={icon ? <img src={MessageDeliveredIcon} alt="Delivered" /> : undefined}
  >
    <ContentHeader
      user={user}
      headerFrom={headerFrom}
      subject={subject}
      date={date}
      content={content}
      info="EmailInfo"
    />
  </ActionBase>
)

export default DeliverAction
